/* =====================================================
   Luxury Brand Statement — interactions
   - IntersectionObserver stagger reveal
   - Smooth scroll-driven parallax for visual element
   - Respects prefers-reduced-motion
   ===================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.lsInit === '1') return;
    section.dataset.lsInit = '1';

    var reveals = section.querySelectorAll('[data-ls-reveal]');
    var visual = section.querySelector('[data-ls-visual]');
    var parallax = section.querySelector('[data-ls-parallax]');

    /* ---------- Reveal ---------- */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
      if (visual) visual.classList.add('is-visible');
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      if (visual) io.observe(visual);
    }

    /* ---------- Parallax (desktop, fine pointer) ---------- */
    if (!parallax || reduceMotion) return;
    var fine = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
    if (!fine) return;

    var ticking = false;
    var inView = false;

    var visIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { inView = e.isIntersecting; });
    }, { threshold: 0 });
    visIo.observe(section);

    function update() {
      ticking = false;
      if (!inView) return;
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // progress: -1 (entering) → 0 (centered) → 1 (leaving)
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + rect.height / 2);
      if (progress < -1) progress = -1;
      if (progress > 1) progress = 1;
      var translate = progress * -28; // px
      parallax.style.transform = 'translate3d(0, ' + translate.toFixed(2) + 'px, 0)';
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lux-statement]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
